const threshold = 0.1
const options = {
  root: null,
  rootMargin: "0px",
  threshold,
}

function handleIntersect(entries, observer) {
  entries.forEach((entry) => {
    if (entry.intersectionRatio > threshold) {
      console.log(entry)
      entry.target.classList.remove("reveal-active")
      observer.unobserve(entry.target)
    }
  })
}

window.addEventListener("DOMContentLoaded", () => {
  const observer = new IntersectionObserver(handleIntersect, options)
  document.querySelectorAll(".reveal").forEach((target) => {
    target.classList.add("reveal-active")
    observer.observe(target)
  })
})
